import React, {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {useCart} from "../context/CartContext";
import StarRating from "./StarRating";
import "./ProductCard.css";

export default function ProductCard({product}) {
  const {addToCart} = useCart();
  const navigate = useNavigate();
  const [added, setAdded] = useState(false);
  const primary =
    product.images?.find((i) => i.isPrimary) || product.images?.[0];
  const hover = product.images?.find((i) => i !== primary) || primary;

  const discount =
    product.originalPrice && product.originalPrice > product.price
      ? Math.round(
          ((product.originalPrice - product.price) / product.originalPrice) *
            100,
        )
      : null;

  function handleAdd(e) {
    e.preventDefault();
    e.stopPropagation();
    // Customised products need a name first, which is entered on the product page
    if (product.isCustomizable) {
      navigate(`/products/${product.slug || product._id}`);
      return;
    }
    addToCart(product);
    setAdded(true);
    setTimeout(() => setAdded(false), 1400);
  }

  return (
    <div className="pc-card">
      <Link
        to={`/products/${product.slug || product._id}`}
        className="pc-media-link"
      >
        <div className="pc-media">
          <img
            src={
              primary?.url ||
              "https://placehold.co/400x400/ece2c9/8a7f66?text=Product"
            }
            alt={primary?.alt || product.name}
            className="pc-img pc-img-front"
            loading="lazy"
          />
          {hover && hover !== primary && (
            <img
              src={hover.url}
              alt=""
              className="pc-img pc-img-back"
              loading="lazy"
            />
          )}

          {product.isBestseller && <span className="pc-tag">Trending Now</span>}
          {discount && (
            <span className="pc-tag pc-tag-sale">{discount}% Off</span>
          )}
        </div>
      </Link>

      <Link to={`/products/${product.slug || product._id}`} className="pc-body">
        {product.category?.name && (
          <span className="pc-category">{product.category.name}</span>
        )}
        <h3 className="pc-name">{product.name}</h3>

        {product.reviewCount > 0 && (
          <div className="pc-rating">
            <StarRating value={product.rating} size={12} />
            <span className="pc-review-count">
              {product.rating.toFixed(1)} ({product.reviewCount})
            </span>
          </div>
        )}

        <div className="pc-price-row">
          <span className="pc-price">
            ₹{Number(product.price).toLocaleString("en-IN")}
          </span>
          {product.originalPrice && product.originalPrice > product.price && (
            <span className="pc-original">
              ₹{Number(product.originalPrice).toLocaleString("en-IN")}
            </span>
          )}
        </div>
      </Link>

      <button
        type="button"
        className={`pc-add btn-pill outline ${added ? "added" : ""}`}
        onClick={handleAdd}
        disabled={product.stock === 0}
      >
        <span className="pc-add-icon" aria-hidden="true">
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
            <path d="M3 6h18" />
            <path d="M16 10a4 4 0 0 1-8 0" />
          </svg>
        </span>
        {product.stock === 0
          ? "Sold out"
          : added
            ? "Added ✓"
            : product.isCustomizable
              ? "Personalise"
              : "Add to cart"}
      </button>
    </div>
  );
}
